import {
  createActions, asyncSelectors, asyncInitialState
} from '../utils'

export const { types, actions } = createActions({
  setSelected: (row) => ({ row }),
  clear: () => null
}, 'serviceOrders');

//const actionListAPI = '/purchaseOrderEnquiry/lookup/action';

const initialState = asyncInitialState({
  selected: null,
  gridOptions: {
    doubleClickActionTab: 'LineDetails',
    suppressEditDeleteInContextMenu: true,
    rowModelType: 'serverSide',
    cacheBlockSize: 10,
    maxBlocksInCache: 5
  },
  deleteObj: null,
  Actions: {
  },
  Columns: [
    { headerName: 'P/O Line', field: 'PurchaseOrderLineNumber', type: 'numericColumn', minWidth: 150 },
    {
      headerName: 'Product', field: 'ProductIdDisplay',
      suppressSorting: true,
      cellRenderer: 'hyperLinkRenderer',
      cellRendererParams: {
        link: '/inventory-enquiry'
      },
      minWidth: 150,
      hyperlinkParamGetter: (row) => {
        if (row.data && row.data.ProductId) {
          return {
            ProductId: row.data.ProductId,
            FieldValue: row.data.ProductIdDisplay
          };
        } else return null;
      },
    },
    { headerName: 'Priority', field: 'Priority', minWidth: 150 },
    { headerName: 'Service order', field: 'ServiceOrder', minWidth: 150 },
    { headerName: 'Committed', field: 'QtyCommittedDisplay', type: 'numericColumn', suppressSorting: true, minWidth: 150 },
    { headerName: 'User ID', field: 'UserId', type: 'numericColumn', suppressSorting: true, minWidth: 150 },
    { headerName: 'Required', field: 'RequiredDate', suppressSorting: true, minWidth: 150 },
    { headerName: 'Order status', field: 'Status', suppressSorting: true, minWidth: 150 },
    {
      headerName: 'Customer', field: 'CustomerIdDisplay',
      cellRenderer: 'hyperLinkRenderer',
      cellRendererParams: {
        link: '/customer-enquiry'
      },
      minWidth: 150,
      hyperlinkParamGetter: (row) => {
        if (row.data && row.data.CustomerId) {
          return {
            CustomerId: row.data.CustomerId,
            FieldValue: row.data.CustomerIdDisplay
          };
        } else return null;
      },
      suppressSorting: true
    },
    { headerName: 'Customer P/O', field: 'CustomerPO', suppressSorting: true, minWidth: 150 },
    { headerName: 'Customer name', field: 'CustomerIdLabel', suppressSorting: true, minWidth: 150 },
    { headerName: 'Product group', field: 'ProductGroup', suppressSorting: true, minWidth: 150 },
    { headerName: 'Product description', field: 'ProductIdLabel', suppressSorting: true, minWidth: 150 },
    { headerName: 'Service order description', field: 'ServiceOrderDescription', suppressSorting: true, minWidth: 150 },
  ]
});

export default (state = initialState, action) => {
  switch (action.type) {
    case types.clear:
      return {
        ...state,
        data: {
          ...state.data,
          Data: []
        }
      }

    case types.setSelected:
      const selected = action.data.row;
      return {
        ...state,
        data: {
          ...state.data,
          selected: selected
        }
      }
    default:
      return state;
  }
};

const asyncSelector = asyncSelectors(
  (state) => state.purchaseOrderEnquiry.serviceOrders,
  {
    selected: data => data.selected,
    Actions: data => data.Actions,
  }
)

const syncSelector = {
  isLoading: state => state.purchaseOrderEnquiry.serviceOrders.loading,
  gridOptions: state => state.purchaseOrderEnquiry.serviceOrders.data.gridOptions,
  Columns: state => state.purchaseOrderEnquiry.serviceOrders.data.Columns,
  Actions: state => state.purchaseOrderEnquiry.serviceOrders.data.Actions,
}

export const selectors = Object.assign({}, asyncSelector, syncSelector)